import { useClientApiV1CouponsInstructorCreateMutation, API_ENDPOINT } from '../../@types/schema';

export const INSTRUCTOR_COUPON_ERROR_CODE_KEY = {
  INVALID_COURSE: 'INVALID_COURSE',
  INVALID_DISCOUNT_PRICE: 'INVALID_DISCOUNT_PRICE',
  INVALID_DISCOUNT_PRICE_UNIT: 'INVALID_DISCOUNT_PRICE_UNIT',
  EXCEED_LIMIT_COUNT: 'EXCEED_LIMIT_COUNT',
  INVALID_ENDED_AT: 'INVALID_ENDED_AT',
} as const;

export const INSTRUCTOR_COUPON_ERROR_CODE_MESSAGE = {
  [INSTRUCTOR_COUPON_ERROR_CODE_KEY.INVALID_COURSE]: '쿠폰 발급이 불가능한 강의입니다.',
  [INSTRUCTOR_COUPON_ERROR_CODE_KEY.INVALID_DISCOUNT_PRICE]:
    '쿠폰 금액은 강의 가격을 초과할 수 없습니다.',
  [INSTRUCTOR_COUPON_ERROR_CODE_KEY.INVALID_DISCOUNT_PRICE_UNIT]:
    '100원 단위로 할인 금액을 입력해주세요.',
  [INSTRUCTOR_COUPON_ERROR_CODE_KEY.EXCEED_LIMIT_COUNT]: '최대 발급 수량은 999개까지 가능합니다.',
  [INSTRUCTOR_COUPON_ERROR_CODE_KEY.INVALID_ENDED_AT]: '쿠폰 만료일은 생성일로부터 최소 3일입니다.',
} as const;

export type InstructorCouponErrorCode =
  (typeof INSTRUCTOR_COUPON_ERROR_CODE_KEY)[keyof typeof INSTRUCTOR_COUPON_ERROR_CODE_KEY];

interface UseCouponsInstructorCreateMutation {
  options?: Parameters<typeof useClientApiV1CouponsInstructorCreateMutation>[0]['options'];
}

function useCouponsInstructorCreateMutation({ options }: UseCouponsInstructorCreateMutation) {
  return useClientApiV1CouponsInstructorCreateMutation({
    url: API_ENDPOINT.CLIENT_V1_COUPONS_INSTRUCTOR,
    options,
  });
}

export default useCouponsInstructorCreateMutation;
